import React from "react";
import Header from "../components/Header";
import GetInTouch from "../components/GetInTouch";
import AdditionalContactInfo from "../components/AdditionalContactInfo";

const ContactPage: React.FC = () => {
  return (
    <>
      <style>
        {`
          /* =========================================================
             GLOBAL CONTACT PAGE
          ========================================================= */

          html {
            scroll-behavior: smooth;
          }

          body {
            margin: 0;
            padding: 0;
            background: #030508;
          }

          .gv-contact-page {
            width: 100%;
            min-height: 100vh;

            color: #ffffff;

            background:
              radial-gradient(
                circle at 10% 15%,
                rgba(0, 217, 255, 0.07),
                transparent 28%
              ),
              radial-gradient(
                circle at 90% 45%,
                rgba(139, 92, 246, 0.07),
                transparent 30%
              ),
              #030508;

            overflow-x: hidden;
          }

          .gv-contact-page *,
          .gv-contact-page *::before,
          .gv-contact-page *::after {
            box-sizing: border-box;
          }

          .gv-contact-container {
            width: 100%;
            max-width: 1200px;

            margin: 0 auto;

            padding-left: 24px;
            padding-right: 24px;
          }


          /* =========================================================
             HERO
          ========================================================= */

          .gv-contact-hero {
            position: relative;

            padding: 85px 0 105px;

            overflow: hidden;

            text-align: center;
          }

          .gv-contact-grid {
            position: absolute;

            inset: 0;

            background-image:
              linear-gradient(
                rgba(255,255,255,0.025) 1px,
                transparent 1px
              ),
              linear-gradient(
                90deg,
                rgba(255,255,255,0.025) 1px,
                transparent 1px
              );

            background-size: 40px 40px;

            mask-image:
              linear-gradient(
                to bottom,
                black,
                transparent
              );

            pointer-events: none;
          }

          .gv-contact-glow-left {
            position: absolute;

            width: 420px;
            height: 420px;

            left: -220px;
            top: -180px;

            border-radius: 50%;

            background: rgba(0, 217, 255, 0.11);

            filter: blur(100px);

            pointer-events: none;
          }

          .gv-contact-glow-right {
            position: absolute;

            width: 400px;
            height: 400px;

            right: -200px;
            bottom: -220px;

            border-radius: 50%;

            background: rgba(139, 92, 246, 0.11);

            filter: blur(100px);

            pointer-events: none;
          }

          .gv-contact-hero-content {
            position: relative;

            z-index: 2;

            max-width: 800px;

            margin: 0 auto;
          }

          .gv-contact-label {
            display: inline-flex;

            align-items: center;

            gap: 9px;

            padding: 9px 16px;

            margin-bottom: 22px;

            border:
              1px solid rgba(0, 217, 255, 0.30);

            border-radius: 8px;

            background:
              rgba(0, 217, 255, 0.04);

            color: #00d9ff;

            font-size: 11px;

            font-weight: 800;

            letter-spacing: 2px;
          }

          .gv-contact-dot {
            width: 7px;
            height: 7px;

            border-radius: 50%;

            background: #00d9ff;

            box-shadow:
              0 0 10px rgba(0, 217, 255, 0.9);
          }

          .gv-contact-title {
            margin: 0;

            font-size:
              clamp(40px, 6vw, 72px);

            line-height: 1.05;

            letter-spacing: -2px;

            font-weight: 800;

            background:
              linear-gradient(
                90deg,
                #ffffff 0%,
                #ffffff 42%,
                #00d9ff 72%,
                #8b5cf6 100%
              );

            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .gv-contact-description {
            max-width: 680px;

            margin: 25px auto 0;

            color: #98a5b6;

            font-size: 17px;

            line-height: 1.8;
          }


          /* =========================================================
             QUICK CONTACT CARDS
          ========================================================= */

          .gv-contact-quick {
            position: relative;

            margin-top: -35px;

            padding-bottom: 75px;

            z-index: 5;
          }

          .gv-contact-quick-grid {
            display: grid;

            grid-template-columns:
              repeat(3, 1fr);

            gap: 18px;
          }

          .gv-contact-card {
            position: relative;

            padding: 28px 24px;

            min-height: 190px;

            border:
              1px solid rgba(255,255,255,0.08);

            border-radius: 15px;

            background:
              linear-gradient(
                145deg,
                rgba(255,255,255,0.055),
                rgba(255,255,255,0.012)
              );

            overflow: hidden;

            transition:
              transform 0.25s ease,
              border-color 0.25s ease;
          }

          .gv-contact-card::before {
            content: "";

            position: absolute;

            left: 15%;
            right: 15%;
            top: 0;

            height: 1px;

            background:
              linear-gradient(
                90deg,
                transparent,
                #00d9ff,
                transparent
              );
          }

          .gv-contact-card:hover {
            transform: translateY(-5px);

            border-color:
              rgba(0,217,255,0.28);
          }

          .gv-contact-icon {
            width: 48px;
            height: 48px;

            display: flex;

            align-items: center;
            justify-content: center;

            border-radius: 11px;

            border:
              1px solid rgba(0,217,255,0.20);

            background:
              rgba(0,217,255,0.07);

            color: #00d9ff;

            font-size: 20px;

            margin-bottom: 18px;
          }

          .gv-contact-card h3 {
            margin: 0 0 8px;

            font-size: 18px;
          }

          .gv-contact-card p {
            margin: 0;

            color: #8793a5;

            font-size: 14px;

            line-height: 1.7;
          }


          /* =========================================================
             FORM SECTION
          ========================================================= */

          .gv-contact-main {
            position: relative;

            padding: 90px 0;

            border-top:
              1px solid rgba(255,255,255,0.05);

            overflow: hidden;
          }

          .gv-contact-main-grid {
            display: grid;

            grid-template-columns:
              minmax(0, 1.5fr)
              minmax(280px, 0.8fr);

            gap: 55px;

            align-items: start;
          }

          .gv-contact-heading {
            margin-bottom: 35px;
          }

          .gv-contact-heading-label {
            color: #00d9ff;

            font-size: 11px;

            font-weight: 800;

            letter-spacing: 2px;

            text-transform: uppercase;

            margin-bottom: 12px;
          }

          .gv-contact-heading h2 {
            margin: 0;

            font-size:
              clamp(30px, 4vw, 46px);

            line-height: 1.15;

            font-weight: 800;
          }

          .gv-contact-heading p {
            max-width: 650px;

            margin: 16px 0 0;

            color: #8f9bab;

            line-height: 1.8;

            font-size: 15px;
          }


          /* =========================================================
             EXISTING GET IN TOUCH COMPONENT
          ========================================================= */

          .gv-contact-form-wrapper {
            width: 100%;

            min-width: 0;

            padding: 30px;

            border:
              1px solid rgba(255,255,255,0.08);

            border-radius: 18px;

            background:
              linear-gradient(
                145deg,
                rgba(255,255,255,0.045),
                rgba(255,255,255,0.012)
              );

            overflow: hidden;
          }

          .gv-contact-form-wrapper > * {
            max-width: 100% !important;
          }

          .gv-contact-form-wrapper input,
          .gv-contact-form-wrapper textarea,
          .gv-contact-form-wrapper select {
            max-width: 100% !important;
          }

          .gv-contact-form-wrapper img {
            max-width: 100% !important;

            height: auto;
          }


          /* =========================================================
             ADDITIONAL INFO
          ========================================================= */

          .gv-contact-info-wrapper {
            width: 100%;

            min-width: 0;

            padding: 28px;

            border:
              1px solid rgba(255,255,255,0.08);

            border-radius: 18px;

            background:
              linear-gradient(
                145deg,
                rgba(139,92,246,0.07),
                rgba(255,255,255,0.012)
              );

            overflow: hidden;
          }

          .gv-contact-info-wrapper > * {
            max-width: 100% !important;
          }

          .gv-contact-info-wrapper img {
            max-width: 100% !important;

            height: auto;
          }


          /* =========================================================
             BOTTOM CTA
          ========================================================= */

          .gv-contact-cta {
            padding: 80px 0 100px;
          }

          .gv-contact-cta-box {
            position: relative;

            padding: 60px 30px;

            text-align: center;

            overflow: hidden;

            border:
              1px solid rgba(0,217,255,0.18);

            border-radius: 20px;

            background:
              radial-gradient(
                circle at 50% 0%,
                rgba(0,217,255,0.12),
                transparent 50%
              ),
              #070b12;
          }

          .gv-contact-cta-box h2 {
            margin: 0;

            font-size:
              clamp(28px, 4vw, 44px);
          }

          .gv-contact-cta-box p {
            max-width: 620px;

            margin: 15px auto 0;

            color: #8e9aaa;

            line-height: 1.8;
          }


          /* =========================================================
             TABLET
          ========================================================= */

          @media (max-width: 900px) {

            .gv-contact-quick-grid {
              grid-template-columns:
                repeat(2, 1fr);
            }

            .gv-contact-main-grid {
              grid-template-columns: 1fr;

              gap: 35px;
            }
          }


          /* =========================================================
             MOBILE
          ========================================================= */

          @media (max-width: 600px) {

            .gv-contact-container {
              padding-left: 16px;
              padding-right: 16px;
            }

            .gv-contact-hero {
              padding:
                55px 0 75px;
            }

            .gv-contact-title {
              font-size: 40px;

              letter-spacing: -1px;
            }

            .gv-contact-description {
              font-size: 14px;

              line-height: 1.75;
            }

            .gv-contact-quick {
              margin-top: 0;

              padding-bottom: 40px;
            }

            .gv-contact-quick-grid {
              grid-template-columns: 1fr;

              gap: 12px;
            }

            .gv-contact-card {
              min-height: auto;

              padding: 24px 20px;
            }

            .gv-contact-main {
              padding: 60px 0;
            }

            .gv-contact-main-grid {
              grid-template-columns: 1fr;

              gap: 30px;
            }

            .gv-contact-heading {
              margin-bottom: 25px;
            }

            .gv-contact-heading h2 {
              font-size: 30px;
            }

            .gv-contact-heading p {
              font-size: 14px;
            }

            .gv-contact-form-wrapper {
              padding: 18px;

              border-radius: 14px;
            }

            .gv-contact-info-wrapper {
              padding: 20px;

              border-radius: 14px;
            }

            .gv-contact-cta {
              padding: 55px 0 70px;
            }

            .gv-contact-cta-box {
              padding: 45px 20px;

              border-radius: 16px;
            }
          }


          /* =========================================================
             VERY SMALL MOBILE
          ========================================================= */

          @media (max-width: 380px) {

            .gv-contact-title {
              font-size: 34px;
            }

            .gv-contact-label {
              font-size: 9px;

              letter-spacing: 1.5px;
            }

            .gv-contact-description {
              font-size: 13px;
            }

            .gv-contact-form-wrapper {
              padding: 14px;
            }
          }
        `}
      </style>

      <div className="gv-contact-page">

        {/* =======================================================
            HEADER
        ======================================================= */}

        <Header />


        {/* =======================================================
            HERO
        ======================================================= */}

        <section className="gv-contact-hero">

          <div className="gv-contact-grid" />

          <div className="gv-contact-glow-left" />

          <div className="gv-contact-glow-right" />

          <div className="gv-contact-container">

            <div className="gv-contact-hero-content">

              <div className="gv-contact-label">
                <span className="gv-contact-dot" />
                GET IN TOUCH
              </div>

              <h1 className="gv-contact-title">
                Let's Connect.
              </h1>

              <p className="gv-contact-description">
                Have a question, need help, or want to know more about
                Growniverse? Our team is here to listen, help, and guide
                you in the right direction.
              </p>

            </div>

          </div>

        </section>


        {/* =======================================================
            QUICK CONTACT
        ======================================================= */}

        <section className="gv-contact-quick">

          <div className="gv-contact-container">

            <div className="gv-contact-quick-grid">

              <div className="gv-contact-card">

                <div className="gv-contact-icon">
                  ✉
                </div>

                <h3>
                  Email Us
                </h3>

                <p>
                  Send us your questions, feedback, or enquiries and
                  our team will get back to you.
                </p>

              </div>


              <div className="gv-contact-card">

                <div className="gv-contact-icon">
                  ◎
                </div>

                <h3>
                  Need Guidance?
                </h3>

                <p>
                  Not sure where to start? Tell us what you are looking
                  for and we will help you find the right direction.
                </p>

              </div>


              <div className="gv-contact-card">

                <div className="gv-contact-icon">
                  ◈
                </div>

                <h3>
                  Grow With Us
                </h3>

                <p>
                  Connect with Growniverse and become part of a
                  community focused on continuous learning and growth.
                </p>

              </div>

            </div>

          </div>

        </section>


        {/* =======================================================
            CONTACT FORM + INFORMATION
        ======================================================= */}

        <section className="gv-contact-main">

          <div className="gv-contact-container">

            <div className="gv-contact-main-grid">

              {/* LEFT */}

              <div>

                <div className="gv-contact-heading">

                  <div className="gv-contact-heading-label">
                    SEND A MESSAGE
                  </div>

                  <h2>
                    How can we help?
                  </h2>

                  <p>
                    Fill in the details below and send us a message.
                    Whether you have a question about courses,
                    internships, your account, or anything else,
                    we would love to hear from you.
                  </p>

                </div>


                <div className="gv-contact-form-wrapper">

                  <GetInTouch />

                </div>

              </div>


              {/* RIGHT */}

              <div>

                <div className="gv-contact-heading">

                  <div className="gv-contact-heading-label">
                    CONTACT INFORMATION
                  </div>

                  <h2>
                    We're here for you.
                  </h2>

                  <p>
                    Explore the ways you can connect with the
                    Growniverse team.
                  </p>

                </div>


                <div className="gv-contact-info-wrapper">

                  <AdditionalContactInfo />

                </div>

              </div>

            </div>

          </div>

        </section>


        {/* =======================================================
            CTA
        ======================================================= */}

        <section className="gv-contact-cta">

          <div className="gv-contact-container">

            <div className="gv-contact-cta-box">

              <div className="gv-contact-label">
                GROWNIVERSE
              </div>

              <h2>
                Keep learning. Keep growing.
              </h2>

              <p>
                Every question is a step toward something new.
                Connect with us and let's continue the journey together.
              </p>

            </div>

          </div>

        </section>

      </div>
    </>
  );
};

export default ContactPage;